var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Tramitex_props, _Tramitex_companyTypes, _Tramitex_contactTypes, _Tramitex_disabilities, _Tramitex_educationLevels, _Tramitex_ethnicGroups, _Tramitex_genders, _Tramitex_identificationTypes, _Tramitex_PreferentialTreatment, _Tramitex_procedures, _Tramitex_professions, _Tramitex_ageRanges, _Tramitex_orientationSectors;
import { ReadonlyCollection } from '@ioip/core/lib/types';
import { CompanyType } from './CompanyType';
import { ContactType } from './ContactType';
import { Disability } from './Disability';
import { EducationLevel } from './EducationLevel';
import { EthnicGroup } from './EthnicGroup';
import { Gender } from './Gender';
import { IdentificationType } from './IdentificationType';
import { Procedure } from './Procedure';
import { Profession } from './Profession';
import { PreferentialTreatment } from './PreferentialTreatment';
import { AgeRange } from './AgeRange';
import { OrientationSector } from './OrientationSector';
export class Tramitex {
    constructor(props) {
        _Tramitex_props.set(this, void 0);
        _Tramitex_companyTypes.set(this, new ReadonlyCollection([]));
        _Tramitex_contactTypes.set(this, new ReadonlyCollection([]));
        _Tramitex_disabilities.set(this, new ReadonlyCollection([]));
        _Tramitex_educationLevels.set(this, new ReadonlyCollection([]));
        _Tramitex_ethnicGroups.set(this, new ReadonlyCollection([]));
        _Tramitex_genders.set(this, new ReadonlyCollection([]));
        _Tramitex_identificationTypes.set(this, new ReadonlyCollection([]));
        _Tramitex_PreferentialTreatment.set(this, new ReadonlyCollection([]));
        _Tramitex_procedures.set(this, new ReadonlyCollection([]));
        _Tramitex_professions.set(this, new ReadonlyCollection([]));
        _Tramitex_ageRanges.set(this, new ReadonlyCollection([]));
        _Tramitex_orientationSectors.set(this, new ReadonlyCollection([]));
        __classPrivateFieldSet(this, _Tramitex_props, props, "f");
    }
    get Version() { return "2.0.0"; }
    get Procedures() {
        return __classPrivateFieldGet(this, _Tramitex_procedures, "f");
    }
    get AgeRanges() {
        return __classPrivateFieldGet(this, _Tramitex_ageRanges, "f");
    }
    get CompanyTypes() {
        return __classPrivateFieldGet(this, _Tramitex_companyTypes, "f");
    }
    get ContactTypes() {
        return __classPrivateFieldGet(this, _Tramitex_contactTypes, "f");
    }
    get Disabilities() {
        return __classPrivateFieldGet(this, _Tramitex_disabilities, "f");
    }
    get EducationLevels() {
        return __classPrivateFieldGet(this, _Tramitex_educationLevels, "f");
    }
    get EthnicGroups() {
        return __classPrivateFieldGet(this, _Tramitex_ethnicGroups, "f");
    }
    get Genders() {
        return __classPrivateFieldGet(this, _Tramitex_genders, "f");
    }
    get IdentificationTypes() {
        return __classPrivateFieldGet(this, _Tramitex_identificationTypes, "f");
    }
    get PreferentialTreatments() {
        return __classPrivateFieldGet(this, _Tramitex_PreferentialTreatment, "f");
    }
    get Professions() {
        return __classPrivateFieldGet(this, _Tramitex_professions, "f");
    }
    get OrientationSectors() {
        return __classPrivateFieldGet(this, _Tramitex_orientationSectors, "f");
    }
    async loadCompanyTypesAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getCompanyTypesAsync();
        __classPrivateFieldSet(this, _Tramitex_companyTypes, new ReadonlyCollection(items || []).select(x => new CompanyType({ schema: x })), "f");
    }
    async loadContactTypesAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getContactTypesAsync();
        __classPrivateFieldSet(this, _Tramitex_contactTypes, new ReadonlyCollection(items || []).select(x => new ContactType({ schema: x })), "f");
    }
    async loadDisabilitiesAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getDisabilitiesAsync();
        __classPrivateFieldSet(this, _Tramitex_disabilities, new ReadonlyCollection(items || []).select(x => new Disability({ schema: x })), "f");
    }
    async loadEducationLevelsAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getEducationLevelsAsync();
        __classPrivateFieldSet(this, _Tramitex_educationLevels, new ReadonlyCollection(items || []).select(x => new EducationLevel({ schema: x })), "f");
    }
    async loadEthnicGroupsAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getEthnicGroupsAsync();
        __classPrivateFieldSet(this, _Tramitex_ethnicGroups, new ReadonlyCollection(items || []).select(x => new EthnicGroup({ schema: x })), "f");
    }
    async loadGendersAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getGendersAsync();
        __classPrivateFieldSet(this, _Tramitex_genders, new ReadonlyCollection(items || []).select(x => new Gender({ schema: x })), "f");
    }
    async loadIdentificationTypesAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getIdentificationTypesAsync();
        __classPrivateFieldSet(this, _Tramitex_identificationTypes, new ReadonlyCollection(items || []).select(x => new IdentificationType({ schema: x })), "f");
    }
    async loadPreferentialTreatmentsAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getPreferentialTreatmentsAsync();
        __classPrivateFieldSet(this, _Tramitex_PreferentialTreatment, new ReadonlyCollection(items || []).select(x => new PreferentialTreatment({ schema: x })), "f");
    }
    async loadProfessionsAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getProfessionsAsync();
        __classPrivateFieldSet(this, _Tramitex_professions, new ReadonlyCollection(items || []).select(x => new Profession({ schema: x })), "f");
    }
    async loadOrientationSectorsAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getOrientationSectorsAsync();
        __classPrivateFieldSet(this, _Tramitex_orientationSectors, new ReadonlyCollection(items || []).select(x => new OrientationSector({ schema: x })), "f");
    }
    async loadProceduresAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getProceduresAsync();
        __classPrivateFieldSet(this, _Tramitex_procedures, new ReadonlyCollection(items || []).select(x => new Procedure({ sdk: this, schema: x })), "f");
    }
    async loadAgeRangesAsync() {
        const items = await __classPrivateFieldGet(this, _Tramitex_props, "f").api.getAgeRangesAsync();
        __classPrivateFieldSet(this, _Tramitex_ageRanges, new ReadonlyCollection(items || []).select(x => new AgeRange({ schema: x })), "f");
    }
}
_Tramitex_props = new WeakMap(), _Tramitex_companyTypes = new WeakMap(), _Tramitex_contactTypes = new WeakMap(), _Tramitex_disabilities = new WeakMap(), _Tramitex_educationLevels = new WeakMap(), _Tramitex_ethnicGroups = new WeakMap(), _Tramitex_genders = new WeakMap(), _Tramitex_identificationTypes = new WeakMap(), _Tramitex_PreferentialTreatment = new WeakMap(), _Tramitex_procedures = new WeakMap(), _Tramitex_professions = new WeakMap(), _Tramitex_ageRanges = new WeakMap(), _Tramitex_orientationSectors = new WeakMap();
